import { useSelector, useDispatch } from "react-redux";
import { useState, useRef, useEffect, useCallback } from "react";
import Cookies from "universal-cookie";
// import LayoutMenu from "./components/LayoutMenu.js";
import { fechaSinGuiones } from "../../tools/ConversionFechas.js";
import BusquedaAlumnos from "../../tools/BusquedaAlumnos.js";

// import OptionPagos from "../pagos-alumnos/OptionPagos.js";
// import MenuSedes from "../../MenuSedesCursos.js";

// import GridPagosAlumnos from "../pagos-alumnos/GridPagos.js";
// import InformacionAlumno from "../dashboard-alumnos/InformacionAlumno.js";
// import GridRegistroBoleta from "../pagos-alumnos/GridRegistroBoleta.js";

// import ResumenPagos from "../pagos-alumnos/ResumenPagos.js";
// import ReinscripcionesInscrito from "../reinscripciones/ReinscripcionesInscrito.js";

import { fetchApi } from "../../tools/index.js"; // Consumir api

// import CompletarDatosPagosAdmin from "./CompletarDatosPagosCursos.js";
// import GridRecuperacionPagos from "../pagos-alumnos/GridRecuperacionPagos.js";
// import FormBoletas from "./components/FormBoletas.js";
// import CancelButton from "../reportes/components/CancelButton.jsx";


import { getCursosAsignadosAlumno } from "../api/BusquedaAlumCursos.api.js";

import { getSedes } from "../api/";

const campos = [
    { name: "Alumno", type: "text", position: "", flag: "Aspirante", id: 1 },
];

const columnas = [
    { name: "Carnet", id: 1, type: "text", resaltado: false, text: "", filter: 1, ordenar: 1, },
    { name: "Alumno", id: 2, type: "text", resaltado: false, text: "", filter: 1, ordenar: 1, },
    { name: "Fecha de ingreso", id: 6, type: "text", resaltado: false, text: "", filter: 0, ordenar: 0, },
    { name: "Email", id: 0, type: "text", resaltado: false, text: "", filter: 1, ordenar: 0, },
    { name: "Celular", id: 3, type: "text", resaltado: false, text: "", filter: 0, ordenar: 0, },
    { name: "Cargos pendientes", id: 7, type: "text", resaltado: false, text: "", filter: 0, ordenar: 0, },
    { name: "Saldo a la fecha", id: 8, type: "text", resaltado: false, text: "", filter: 0, ordenar: 0, },
    { name: "Modalidad", id: 5, type: "text", resaltado: false, text: "", filter: 0, ordenar: 0, },
    { name: "Selección de modalidad", id: 999, type: "text", resaltado: false, text: "Continuar", alt: "Seleccionar", filter: 0, ordenar: 0, },
];

const columnasTraslado = [
    { name: "Carnet", id: 1, type: "text", resaltado: false, text: "", filter: 1, ordenar: 1, },
    { name: "Alumno", id: 2, type: "text", resaltado: false, text: "", filter: 1, ordenar: 1, },
    { name: "Fecha de ingreso", id: 6, type: "text", resaltado: false, text: "", filter: 0, ordenar: 0, },
    { name: "Email", id: 0, type: "text", resaltado: false, text: "", filter: 1, ordenar: 0, },
    { name: "Celular", id: 3, type: "text", resaltado: false, text: "", filter: 0, ordenar: 0, },
    { name: "Cargos pendientes", id: 7, type: "text", resaltado: false, text: "", filter: 0, ordenar: 0, },
    { name: "Saldo a la fecha", id: 8, type: "text", resaltado: false, text: "", filter: 0, ordenar: 0, },
    { name: "Modalidad", id: 5, type: "text", resaltado: false, text: "", filter: 0, ordenar: 0, },
    { name: "Cambio de horario", id: 999, type: "text", resaltado: false, text: "Continuar", alt: "Seleccionar", filter: 0, ordenar: 0, },
];

const BusquedaAlumCursos = ({ urlCursos, state, send, setModal, headers, IdEmp, Traslado }) => {
    const ref = useRef();
    const textoRef = useRef();

    const dispatch = useDispatch();

    const [domNode, setDomNode] = useState(null);
    const resumenRef = useCallback((node) => {
        setDomNode(node);
    }, []);

    const user = useSelector((state) => state.auth.user);
    // const IdEmp = useSelector((state) => state.auth.IdEmp);
    const Carnet = useSelector((state) => state.auth.Carnet);
    const [carnetEstudiante, setCarnetEstudiante] = useState("");
    const [alumnoSeleccionado, setAlumnoSeleccionado] = useState({});
    const [formasPagoColegiatura, setFormasPagoColegiatura] = useState({});
    const [montoVariable, setMontoVariable] = useState(0)
    const [saldoUltimo, setSaldoUltimo] = useState(0)
    const [opcion, setOpcion] = useState("")


    const userObj = JSON.parse(user);
    let SedeChange = useSelector((state) => state.auth.IdSede);
    const SedePref = '5' + SedeChange.substring(1, 2);
    userObj.LoginId = userObj.LoginId.split(" ")
        .map((x) => {
            return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
        })
        .join(" ");

    const cookies = new Cookies();
    const url = cookies.get("__urlCursosApi"); // url para enviar al api viene de cookies

    // const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux

    const [showSearchModal, setShowSearchModal] = useState(true);
    const [showEntrevistaAdmin, setEntrevistaAdmin] = useState(false);
    const [carnetResult, setCarnetResult] = useState([]);

    const [formasPago, setFormasPago] = useState({});

    const [dataInformacion, setDataInformacion] = useState([]);

    const [opcionSelect, setopcionSelect] = useState("");

    const [opcionSede, setopcionSede] = useState("");
    const [opcionCiclo, setopcionCiclo] = useState(2023);

    const [showFormPagos, setshowFormPagos] = useState(false);
    const [showPagar, setshowPagar] = useState(false);

    const [alumnoActivo, setalumnoActivo] = useState(true);

    const [alumnoNuevo, setalumnoNuevo] = useState(false);

    const [isGrid, setIsGrid] = useState(false);

    const [cambioSede, setCambioSede] = useState(false);

    const [resetForm, setresetForm] = useState(false);

    const buttonRefs = useRef([]);
    const textRefs = useRef([])

    const [flagSearch, setFlagSearch] = useState("Aspirante");

    const [filteredData, setFilteredData] = useState([]);
    const [selectedCargos, setSelectedCargos] = useState([]);
    const [filterR, setFilterR] = useState(false);

    const [loading, setLoading] = useState(false);

    const [dataAlumnos, setdataAlumnos] = useState([]);

    const [textoBusqueda, setTextoBusqueda] = useState("");

    const [dataAlumnosBusqueda, setdataAlumnosBusqueda] = useState([]);
    const [dataRecuperacion, setDataRecuperacion] = useState([]);
    const [dataRegistroBoleta, setDataRegistroBoleta] = useState([]);

    const [esColegiatura, setEsColegiatura] = useState(true);
    const [ocultarTotal, setOcultartotal] = useState(false);
    const [esPlan4, setEsPlan4] = useState(false);
    const [showDialogoPlan4, setShowDialogoPlan4] = useState(false);
    const [gridBoletaVisible, setGridBoletaVisible] = useState(false);
    const [descripcion, setDescripcion] = useState()
    const [etapaPago, setEtapaPago] = useState(false)
    const [valorDisabled, setValorDisabled] = useState(false)
    const [datosBoleta, setDatosBoleta] = useState({
        boleta: "",
        banco: "",
        fecha: "",
        saldo: "",
        valor: 0,
    });
    const [textoenGridVisible, setTextoenGridVisible] = useState(false)
    const [checksDisabled, setChecksDisabled] = useState(false)
    const [filtrado, setFiltrado] = useState(false)
    const [index, setIndex] = useState(0)
    const [total, setTotal] = useState(0)
    const [subTotal, setSubtotal] = useState(0)
    const [btnAceptarDisabled, setBtnAceptarDisabled] = useState(true)

    const [posicionado, setPosicionado] = useState(false)
    const [saldoExcedidoChanged, setSaldoExcedidoChanged] = useState(false)
    const [respaldoDetalle, setRespaldoDetalle] = useState(null)

    const initialTextoxValues = [
        { id: 0, visible: false, },
        { id: 1, visible: false, },
        { id: 2, visible: false, },
        { id: 3, visible: false, },
        { id: 4, visible: false, },
        { id: 5, visible: false, },
        { id: 6, visible: false, },
        { id: 7, visible: false, },
        { id: 8, visible: false, },
        { id: 9, visible: false, },
        { id: 10, visible: false, },
        { id: 11, visible: false, },
        { id: 12, visible: false, },
        { id: 13, visible: false, },
        { id: 14, visible: false, },
        { id: 15, visible: false, },
        { id: 16, visible: false, },
    ]


    const [textos, setTextos] = useState(initialTextoxValues)
    const [formDisabled, setFormDisabled] = useState(false)

    const [optionPago, setOptionPago] = useState("Colegiaturas");
    const [optColegiaturas, setOptColegiaturas] = useState(true);
    const [optRecuperacion, setOptRecuperacion] = useState(false);
    const [encabezadoBoleta, setEncabezadoBoleta] = useState()

    const valorRef = useRef();


    //Manejo de errores
    // const [modal, setModal] = useState({
    //     show: false,
    //     msg: "",
    //     ok: false,
    // });
    /*
    const moverComponent = () => {
      ref.current.scrollIntoView();
    };
    */

    const [dataCursos, setDataCursos] = useState();
    const [estado, setEstado] = useState("");
    const [showForm, setShowForm] = useState(false)

    const [modalidad, setModalidad] = useState(0);

    const configObjPerfiles = {
        url: url + "/perfilalumno/perfilesfamilia",
        headers,
        content: {
            IdFamilia: IdEmp,
        },
    };

    const clickClosed = (data) => {
        data?.map(function (d, index, array) {
            let clickedButton = buttonRefs.current[index];
            if (clickedButton?.getAttribute("data-value") == "true") {
                clickedButton?.click();
            }
        });
    };

    const clickOpen = (data) => {
        data?.map(function (d, index, array) {
            let clickedButton = buttonRefs.current[index];
            if (clickedButton?.getAttribute("data-value") == "false") {
                clickedButton?.click();
            }
        });
    };

    const handleChangeSearch = (dato) => {
        setdataAlumnos([]);
        setdataAlumnosBusqueda([]);
        setTextoBusqueda("");
        setFlagSearch(dato);
        setresetForm(true);
        setIsGrid(true);
    };

    const handleClick = async (dato, ciclo) => {
        setdataAlumnos([]);
        setdataAlumnosBusqueda([]);

        // if (!textoBusqueda || textoBusqueda.length < 3) {
        //      return;
        // }

        let ciclos = 0;
        let Sede = "";

        switch (dato) {
            case "Calzada San Juan":
                Sede = "51";
                break;
            case "Avenida Petapa":
                Sede = "52";
                break;
            case "Aguilar Batres":
                Sede = "54";
                break;
            case "Zona 6":
                Sede = "55";
                break;
            case "San Cristóbal":
                Sede = "56";
                break;
            default:
                break;
        }

        if (ciclo.Actuales) {
            ciclos = 2023;
        } else {
            ciclos = 2021;
        }

        setopcionSede(Sede);

        if (textoBusqueda === "") {
            return;
        }

        let param = "";
        if (flagSearch === "Aspirante") {
            param = {
                Opcion: "ALUMNOS_V2",
                IdSede: Sede,
                Aspirante: textoBusqueda,
            };
        } else {
            param = {
                Opcion: "ALUMNOS_V2",
                IdSede: Sede,
                Carnet: textoBusqueda,
            };
        }


        try {

            const res = await fetchApi({
                url: url + "/utils/busquedas",
                headers,
                content: param,
            });



            if (res.length === 0) {
                setdataAlumnos([]);
                setdataAlumnosBusqueda([]);
                setresetForm(false);
                setIsGrid(true);
            } else {
                setresetForm(false);
                setIsGrid(false);
                setdataAlumnos(res);
                setdataAlumnosBusqueda(res);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getSedes(urlCursos, send, headers)
        if (
            opcionSede === "" ||
            opcionSede === undefined ||
            opcionSede === false ||
            opcionSede === null ||
            opcionSede === "00"
        ) {
            setopcionSede("");
        }
        if (!textoBusqueda || textoBusqueda.length < 3) {
            return;
        }
        // setdataAlumnosBusqueda(dataAlumnos);
        // console.log('alumnos: ', dataAlumnos)        
    }, []);

    const habilitarFormBoleta = () => {
        setFormDisabled(false)
    }


    const fetchDataCta = async (dataPerfil, Carnet) => {
        // llamar al combo delos bancos
        try {
            setLoading(true);
            setalumnoNuevo(false);
            const arrayCarnets = [{ Carnet }];
            const resProps = await fetchApi({
                url: url + "/pagos/getalumno_v2",
                headers,
                content: {
                    CanalPagos: 2,
                    Alumnos: arrayCarnets,
                },
            });

            if (
                resProps[0].Efectivo === false &&
                resProps[0].TC === false &&
                resProps[0].POS === false &&
                resProps[0].Abonos === false &&
                resProps[0].Cheque === false &&
                resProps[0].Deposito === false
            ) {
                setOcultartotal(() => true);
            } else {
                setOcultartotal(() => false);
            }
            setFormasPago({ Efectivo: resProps[0].Efectivo, TC: resProps[0].TC }); // al ser recuperacion cambia a los primertos que devuelve el api
            setFormasPagoColegiatura({
                Efectivo: resProps[0].Efectivo,
                TC: resProps[0].TC,
            });
            const resPerfil = await fetchApi({
                url: url + "/perfilalumno/dashboard",
                headers,
                content: {
                    Carnet,
                },
            });

            setDataInformacion(resPerfil.msg[0]);

            if (resPerfil.msg[0].Estado === "Inactivo") {
                setalumnoActivo(false);
            } else {
                setalumnoActivo(true);
                const res = await fetchApi({
                    url: url + "/pagos/ctaalumno",
                    headers,
                    content: {
                        Alumnos: arrayCarnets,
                    },
                });
                if (res.msg?.Mensaje === "Alumno no tiene cargos pendientes.") {
                    setalumnoNuevo(true);
                } else {
                    filterData(res, dataPerfil);
                }
            }
            setLoading(false);
            setFilterR(true);

            filteredData?.map(function (d, index, array) {
                let clickedButton = buttonRefs.current[index];
                if (clickedButton?.getAttribute("data-value") == "false") {
                    clickedButton?.click();
                }
            });

            setshowFormPagos(true);
        } catch (err) {
            console.log(err);
        }
    };

    const handleAlumnoCta = (carnet) => {
        setCarnetEstudiante(() => carnet.Carnet);
        setAlumnoSeleccionado(() => carnet);
        setEsPlan4(() => false);
        setEsColegiatura(true);
        setOptRecuperacion(() => false);
        setOptColegiaturas(() => true);
        setOptionPago(() => "Colegiaturas");
        fetchDataCta(carnet, carnet.Carnet);

    };

    const filterData = (data, dataF) => {
        let descripcion = data[0].Descrip
        let inicio = descripcion.split(" ")
        setDescripcion(() => inicio[0])

        // con esta funcion es que se llena alumno, detalles
        let newData = [];
        let newDataA = [];

        newDataA.push({
            Carnet: dataF.Carnet, // || alumnoSeleccionado,
            Alumno: dataF.NombreCompleto,
            grado: dataF.Grado,
            Sede: dataF.Sede,
        });

        newData.push({
            Alumnos: {
                Carnet: dataF.Carnet,
                Alumno: dataF.NombreCompleto,
                grado: dataF.Grado,
                Sede: dataF.Sede,
            },
            Detalle: data,
        });
        //console.log(newData, "FilteredData");
        return setFilteredData(newData);
    };

    const handleSeleccion = (carnet, cargo) => {
        setCarnetEstudiante(() => carnet);
        const found = selectedCargos.filter((element) => {
            return element.Carnet === carnet && element.Descrip === cargo;
        });
        let isSelect = false;
        if (found.length > 0) {
            isSelect = true;
        }
        return isSelect;
    };

    const handleSeleccionBoleta = (carnet, cargo) => {
        setCarnetEstudiante(() => carnet);
        const found = selectedCargos.filter((element) => {
            return element.Carnet === carnet && element.Descrip === cargo;
        });
        let isSelect = false;
        if (found.length > 0) {
            isSelect = true;
        }
        return isSelect;
    }

    const handleSeleccionRecuperacion = (IdCargo, IdMateria) => {

        let isSelect = false;
        const found = selectedCargos.filter((element) => {
            return element.IdCargo === IdCargo && element.IdMateria === IdMateria;
        });
        if (found.length > 0) {
            isSelect = true;
        } else {
            isSelect = false;
        }
        return isSelect;
    };

    const handleFilterR = () => {
        if (filterR) {
            setFilterR(false);
            clickClosed(filteredData);
        } else {
            setFilterR(true);
            clickOpen(filteredData);
        }
    };

    const moverIni = () => {
        if (domNode) {
            domNode.scrollIntoView({
                block: "start",
                behavior: "smooth",
            });
        }
    };

    const handleQuitarCargo = (idx, carnet) => {
        // aqui poner la condicional para que al presionar,  no se vayan todos, si es "Recuperacion"
        if (esColegiatura) {
            // 'es colegiatura'
            const dataArr = new Set([
                ...selectedCargos.filter((a) => {
                    return a.Carnet !== carnet;
                }),
                ...selectedCargos.slice(0, idx),
            ]);

            setSelectedCargos([...dataArr]);
        } else {
            let cargos = selectedCargos;
            const dataArr = cargos.splice(idx, 1);
            setSelectedCargos([...cargos]);
        }
    };

    const handleTotal = () => {
        return esPlan4 ?
            selectedCargos.reduce((prev, curr) => prev + curr.Saldo, 0) :
            esColegiatura
                ? selectedCargos.reduce((prev, curr) => prev + curr.Saldo, 0)
                : selectedCargos.reduce((prev, curr) => prev + curr.Valor, 0);
    };

    const handleValidar = (cancelar, modalEntendido = false, modalError) => {
        // CANCELAR
        setGridBoletaVisible(false)
        if (cancelar) {
            setSelectedCargos([]);
            setFilterR(false);
            clickClosed(filteredData);
            setshowPagar(false);
            setshowFormPagos(false);
            setDatosBoleta({})
            if (modalEntendido) {
                setModal({
                    msg: modalError?.msg,
                    ok: modalError?.ok,
                    show: modalError?.show,
                });
            }
            setSelectedCargos([])
            setDataRegistroBoleta([])
            setDatosBoleta({})

        } else {
            setshowPagar(true);
        }
    };



    const getData = async () => {
        // Cargos recuperación y nivelación
        const data = await fetchApi({
            url: url + "/pagos/getalumnorecviv",
            headers,
            content: {
                Carnet: carnetEstudiante,
            },
        });

        setDataRecuperacion([{ Alumnos: alumnoSeleccionado, Detalle: data[0] }]);
        if (
            data[0][0]?.Efectivo === false &&
            data[0][0]?.TC === false &&
            data[0][0]?.POS === false &&
            data[0][0]?.Abonos === false &&
            data[0][0]?.Cheque === false &&
            data[0][0]?.Deposito === false
        ) {
            setOcultartotal(() => true);
        } else {
            setOcultartotal(() => false);
        }
        setFormasPago({ Efectivo: data[0][0]?.Efectivo, TC: data[0][0]?.TC });
    };

    const handleOptionPagos = (name) => {

        setSelectedCargos([]);

        const opciones = {
            Colegiaturas: () => {
                setEsColegiatura(true);
                setOptRecuperacion(() => !optRecuperacion);
                setOptColegiaturas(() => !optColegiaturas);
                //console.log('PROPS:', formasPagoColegiatura)
                setOptionPago(() =>
                    optColegiaturas ? "Recuperacion" : "Colegiaturas"
                );
                if (
                    formasPagoColegiatura?.Efectivo === false &&
                    formasPagoColegiatura?.TC === false
                ) {
                    setOcultartotal(() => true);
                } else {
                    setOcultartotal(() => false);
                }
                setFormasPago({
                    Efectivo: formasPagoColegiatura.Efectivo,
                    TC: formasPagoColegiatura.TC,
                });
            },
            Recuperacion: () => {
                setEsColegiatura(false);
                setOptionPago(() =>
                    optRecuperacion ? "Colegiaturas" : "Recuperacion"
                );
                getData();
                setOptRecuperacion(() => !optRecuperacion);
                setOptColegiaturas(() => !optColegiaturas); // para setear los tipos de pago
            },
            Boleta: () => {
                /*
                console.log('BOLETA: ')
                setGridBoletaVisible(true);
                console.log(id);
                getBoletaData()
                */
            }
        };
        opciones[name]();
    };


    const excecuteModalIndex = (index, alumno) => {
        startGetCursosAsignadosAlumno(alumno, index)
    };

    const startGetCursosTraslado = (alumno, index) => {
        console.log('startGetCursosTraslado', index, alumno)
    }
    //const [] = useState();  // funcion pendiente

    const mensaje = (data) => {
        //


        if (data.Mensaje === 'Boleta Ya Fue Operada' && data.SaldoBoleta === 0 && data.ValorBoleta !== 0) {
            return "Boleta con saldo 0.00" //"Boleta operada"
        }

        if (data.Mensaje === 'Boleta Ya Fue Operada' && data.BoletaExiste === "1" && data.ValorBoleta === 0) {
            return "Boleta no encontrada"
        }
    }

    const getBoletaData = async () => {
        try {
            const res = await fetchApi({
                url: url + "/pagos/getvalidaboleta",
                headers,
                content: {
                    "Numero": datosBoleta.boleta,
                    "IdBanco": datosBoleta.banco,
                    "FechaBoleta": fechaSinGuiones(datosBoleta.fecha),
                    "Carnet": alumnoSeleccionado.Carnet
                },
            });

            if (res === "Recordsets vacio") {
                setModal({
                    ok: false,
                    show: true,
                    msg: "El alumno no tiene cargos pendientes",
                })
            } else {
                setEncabezadoBoleta(() => res)
                if (Object.keys(res.Detalle[0]).length === 0) {
                    setGridBoletaVisible(false);
                    setModal({
                        show: true,
                        msg: mensaje(res),
                        ok: false
                    })
                    setFormDisabled(false)
                } else {
                    if (res.SaldoBoleta < 1) {
                        setModal({
                            ok: false,
                            msg: "La boleta ingresada no tiene saldo",
                            show: true
                        })
                        setGridBoletaVisible(false);
                    } else {
                        setGridBoletaVisible(true);
                        setDataRegistroBoleta([{ Alumnos: alumnoSeleccionado, Detalle: res.Detalle }]);
                        setRespaldoDetalle(() => res.Detalle)
                        setDatosBoleta(datosBoleta => ({
                            ...datosBoleta,
                            saldo: res.SaldoBoleta,
                        }));
                        setFormDisabled(true)
                        setDatosBoleta(datosBoleta => ({
                            ...datosBoleta,
                            valor: parseInt(res.SaldoBoleta)
                        }))
                    }
                }
            }

        } catch (err) {
            console.log(err);
        }
        setChecksDisabled(false)
        setGridBoletaVisible(true);
        setValorDisabled(true)
        setTextoenGridVisible(false)
        setTextos(initialTextoxValues)
    }

    const buscarBoleta = () => {
        getBoletaData()
        setValorDisabled(false)
    };

    const handleFormChange = (e) => {
        setDatosBoleta({
            ...datosBoleta,
            [e.target.name]: e.target.value,
        });
    };

    const handleValorChange = (e, limite) => {

        if (parseInt(e.target.value) > 0) {
            setBtnAceptarDisabled(false)
        } else {
            setBtnAceptarDisabled(true)
        }

        setDatosBoleta({
            ...datosBoleta,
            valor: parseInt(e.target.value)
        })
        if (e.target.value > limite) {
            setModal({
                show: true,
                msg: "El valor de los cargos supera al saldo disponible en la boleta",
                ok: false,
            })
            // limpiar el cuadro de texto
            e.target.value = ""
            setDatosBoleta({
                ...datosBoleta,
                valor: 0
            })
        }
    }

    const pagar = async (cargos) => {
        const data = await fetchApi({
            url: url + '/pagos/pagosalumnos',
            headers: headers,
            method: 'POST',
            content:
            {
                "CanalPago": "2",
                "HostName": "DEV07",
                "IpHost": "131.107.1.235",
                "IdEmp": IdEmp,
                "OS": "Windows",
                "TransBoleta": encabezadoBoleta.IdTransaccion,
                "FormasPago": [
                    {
                        "tipotrans": "3",
                        "NoBoleta": datosBoleta.boleta,
                        "CorrPOS": "0",
                        "IdBanco": datosBoleta.banco,
                        "Valor": total.toString(), // valorPago o 0 cuando se envió solo un item
                        "Fecha": fechaSinGuiones(datosBoleta.fecha),
                        "Saldo": datosBoleta.saldo.toString(),
                    }
                ],
                "AlumnosCargos": cargos
            }
        })

        if (data.msg[0].Error === "0") {
            setModal({
                ok: true,
                show: true,
                msg: data.msg[0].Mensaje
            })
        } else {
            setModal({
                ok: false,
                show: true,
                msg: "No se pudo completar la operación"
            })
        }

        console.log({
            content:
            {
                "CanalPago": "2",
                "HostName": "DEV07",
                "IpHost": "131.107.1.235",
                "IdEmp": IdEmp,
                "OS": "Windows",
                "TransBoleta": encabezadoBoleta.IdTransaccion,
                "FormasPago": [
                    {
                        "tipotrans": "3",
                        "NoBoleta": datosBoleta.boleta,
                        "CorrPOS": "0",
                        "IdBanco": datosBoleta.banco,
                        "Valor": total.toString(),
                        "Fecha": fechaSinGuiones(datosBoleta.fecha),
                        "Saldo": datosBoleta.valor.toString(),
                    }
                ],
                "AlumnosCargos": cargos
            }
        })
    }

    const limpiarForm = () => {
        setChecksDisabled(false)
        setTextos(() => initialTextoxValues)
        setFormDisabled(false)
        setMontoVariable(() => 0)
        setIndex(() => 0)
        handleValidar(true) // regresa a la pantalla inicial
        ///////////
        setValorDisabled(false)
        setGridBoletaVisible(false);
        setDatosBoleta({
            ...datosBoleta,
            valor: 0,
        })
        setBtnAceptarDisabled(true)

        setTextoenGridVisible(false)
        setTextos(initialTextoxValues)
        setSelectedCargos([])
        setDataRegistroBoleta([])
        setDatosBoleta({})
    }

    const limpiarCargos = () => {
        const cargosCopia = [...selectedCargos];
        const cargosLength = selectedCargos.length - 1;
        cargosCopia.forEach((element, index) => {
            delete element["Descrip"]
            delete element["CuotaBase"]
            delete element["ProntoPago"]
            delete element["DesctoReducido"]
            delete element["Paga"]
            delete element["Pagado"]
            delete element["MinimoAbono"]
            delete element["Vence"]
            delete element["Pagar"]
            delete element["TipoCargo"]
            delete element["VencidoReal"]
            delete element["Abonos"]
            element.IdCiclo = element.IdCiclo.toString()
            element.NoPago = element.NoPago.toString()
            element.Saldo = element.Saldo.toString()
            element.Abono = "0"
            if (opcion === "excedido") {
                if (index === cargosLength) {
                    element.Abono = selectedCargos[index].Saldo.toString()
                    element.Saldo = respaldoDetalle[index].Saldo.toString()
                }
            }
        })
        return cargosCopia
    }

    const handlePlan4 = (opcion) => {
        const opciones = {
            "normal": () => {
                setFiltrado(() => false)
                setDatosBoleta(datosBoleta => ({
                    ...datosBoleta,
                    valor: datosBoleta.valor
                }))
                pagar(limpiarCargos())
                limpiarForm()
            },
            "excedido": () => {
                setFiltrado(() => false)
                setDatosBoleta(datosBoleta => ({
                    ...datosBoleta,
                    valor: datosBoleta.valor
                }))
                pagar(limpiarCargos())
                limpiarForm()
            },
        }
        opciones[opcion]()

    }

    const handleRefTextIndex = (Idx) => {
        setIndex(() => Idx)
        if (textos[Idx].visible) {
            setTextos(() => initialTextoxValues)
            setDatosBoleta({
                ...datosBoleta,
                valor: subTotal
            })
        }
    }

    const forzarCambioExcedido = (valor) => {


        const cargosLength = selectedCargos.length - 1

        const newState = selectedCargos.map((element, index) => {
            if (index === cargosLength) {
                return { ...element, Saldo: valor }
            }
            return element // si no se cumple la condicion, se envia el objeto como tal
        })

        setSelectedCargos(newState)

    }

    const changeSaldoExcedido = (valor = 0) => {
        const resta = valor
        const cargosLength = selectedCargos.length - 1
        const newState = selectedCargos.map((element, index) => {
            if (index === cargosLength) {
                return { ...element, Saldo: resta } // cambiar este estado con el texto
            }
            return element
        })
        setSelectedCargos(newState)
        setSaldoExcedidoChanged(true)
    }

    const handleInputChange = (e) => {
        let texto = parseInt(e.target.value)


        if (e.target.value === "") {
            texto = 0
        }
        forzarCambioExcedido(texto)

    }

    const calcularIndice = () => {
        const cargosLength = selectedCargos.length - 1
        setIndex(() => cargosLength)
    }

    const posicionarTexto = () => {
        const textosCopia = textos;
        textosCopia.map((element) => {

            if (element.id === selectedCargos.length - 1) {
                element.visible = true
            } else {
                element.visible = false
            }
        }
        )
        setSaldoUltimo(() => respaldoDetalle[selectedCargos.length - 1].Saldo)
        setTextos(() => textosCopia)
        setPosicionado(() => true)
    }

    const notificar = () => {
        setModal({
            ok: false,
            show: true,
            msg: "Las cuotas seleccionadas superan el saldo disponible en la boleta, corrija la cantidad ingresada por favor o desmarque y marque de nuevo el cargo escedido",
        })
        //setMontoVariable(()=> 0)
    }

    const [montoMaximo, setMontoMaximo] = useState(0)
    const setearMontoVariable = (totalLocal) => {
        const prediferencia = totalLocal - datosBoleta.saldo
        const ultimoSaldo = respaldoDetalle[selectedCargos.length - 1].Saldo
        const monto = ultimoSaldo - prediferencia

        setMontoMaximo(() => selectedCargos[selectedCargos.length - 1].Saldo)

        setDatosBoleta({
            ...datosBoleta,
            montoVariable: monto
        })
        setMontoVariable(() => monto) // capturarlo desde respaldoDetalles
        return monto
    }

    useEffect(() => {
        if (esPlan4) {
            if (selectedCargos.length > 0) { // si se selecciona alguno
                const totalLocal = selectedCargos.reduce((elemento, curr) => {
                    return elemento + curr.Saldo; // tiene pagar
                }, 0)
                setTotal(() => totalLocal)
                if (totalLocal > datosBoleta.saldo) {
                    setModal({
                        show: true,
                        ok: false,
                        msg: "Las cuotas seleccionadas superan el saldo disponible en la boleta"
                    })
                    changeSaldoExcedido(setearMontoVariable(totalLocal)) // enviar max value como el monto variable
                }

                if (totalLocal >= datosBoleta.saldo) {
                    setOpcion(() => "excedido")
                    if (!posicionado) {
                        // modificacion del saldo para obtener el monto variable
                        calcularIndice()
                        posicionarTexto()
                        setearMontoVariable(totalLocal)
                        changeSaldoExcedido(setearMontoVariable(totalLocal))
                        setGridBoletaVisible(true)
                    } else {
                        setGridBoletaVisible(true)
                        posicionarTexto()
                        setearMontoVariable(totalLocal)
                        if (montoVariable < 0) {
                            //'numero negativo, retroceder 1'
                            const copia = [...selectedCargos]
                            const quitado = copia.pop()
                            setSelectedCargos(() => selectedCargos.filter((element) => (
                                element.IdCargo !== quitado.IdCargo
                            )))
                        }
                        //'posicionado'
                    }
                } else {
                    setPosicionado(() => false) // funciona el tema de las sumas pero se desaparecen los textos al ser menor
                    if (!posicionado) {
                        setOpcion(() => "normal")
                        !montoVariable && setTextos(() => initialTextoxValues)//
                        setPosicionado(() => true)
                    } else {
                        // montoVariable , totalLocal , datosBoleta.saldo
                    }
                }

            }
            else {
                // ninguno seleccionado
                // quitar el bloqueo
                // hacer invisible el cuadro de texto
                setOpcion("normal")
                setTextos(() => initialTextoxValues)
            }
        }
        setTextoenGridVisible(false)
    }, [selectedCargos])

    const startGetCursosAsignadosAlumno = async (carnet, alumModalidadIndex = 0) => {
        // e.preventDefault();
        // const alumModalidad = (alumModalidadIndex === 0 ? carnet.Modalidad : alumModalidadIndex)

        const alumModalidad = carnet.Modalidad

        const response = await fetchApi({
            url: urlCursos + "/utils/busquedas",
            headers: headers,
            content: {
                Opcion: "CATALOGOS",
                "Modalidad": alumModalidad,
            },
        });

        send("CARGAR_CATALOGOS", { catalogos: response.msg }); // en el caso de enviar data, se setea el response mediante este metodo "SEND"

        const resProps = await fetchApi({
            url: urlCursos + "/inscripciones/propiedades_pagos",
            headers,
            content: {
                CanalPagos: 7
            },
        });


        const ff = { Efectivo: resProps.msg[0].Efectivo, TC: resProps.msg[0].TC, CanalPagos: 7 }
        send("GUARDAR_FORMASPAGO", { formasp: ff }); // en el caso de enviar data, se setea el response mediante este metodo "SEND"


        const cursosAsignados = await getCursosAsignadosAlumno(urlCursos, headers, carnet) // si no existe, que me envie un response


        send("GUARDAR_CURSOS_ANTES", { CursosAntes: cursosAsignados })
        // filtrar, si tiene el campo Cobrado pero es falso, se debe realizar el calculo del descuento aquí


        setDataCursos(() => cursosAsignados)
        // console.log('ff', state.context.formaspago)
        // console.log('GUARDAR_FORMASPAGO', ff)
        if (cursosAsignados[0]?.Cursos?.length > 0) {

            // jalar y setear los headers aquí
            send("GUARDAR_DATOS_USUARIO", {
                datosUsuario: {
                    "Apellidos": cursosAsignados[0]["Apellidos"],
                    "Cel": cursosAsignados[0]["Cel"],
                    "DPI": cursosAsignados[0]["DPI"],
                    "Email": cursosAsignados[0]["Email"],
                    "NIT": cursosAsignados[0]["NIT"],
                    "NombreDoc": cursosAsignados[0]["NombreDoc"],
                    "Nombres": cursosAsignados[0]["Nombres"],
                    "CodDepto": cursosAsignados[0]["CodDepto"],
                    "Modalidad": alumModalidad,
                }
            })


            // crear el header en esta línea
            let contador = 0
            let toca = 0
            let toca2 = 0
            cursosAsignados[0].Cursos.forEach((element, index) => {
                /* no hay response cuando el dato ingresado no tiene cursos
                   y el id solicitud sí fue creado
                */
                contador = contador + 1
                toca = 0
                toca2 = 0
                const header = {
                    "IdSede": element["IdSede"],
                    "IdCurso": element["IdCurso"],
                    "IdHorario": element["IdHorario"],
                    "IdPlan": element["IdPlan"],
                    "IdPeriodo": element["IdPeriodo"],
                    "NombreCurso": element["NombreCurso"],
                    "NombrePlan": element["NombrePlan"],
                    "DescripcionPlan": element["DescripcionPlan"],
                    "DuraMes": element["DuraMes"],
                    "Modalidad": element["Modalidad"],
                    "Dias": element["Dias"],
                    "IdPeriodo": element["IdPeriodo"],
                    "Imagen": element["Imagen"],
                }
                element["Cargos"][0]["Header"] = header
                element.Cargos.forEach((cargo, indexCargo) => {
                    contador = contador + 1
                    toca2 = toca2 + 1

                    if (cargo.Cobrado === false) {
                        toca = toca + 1
                    }
                    cargo.IdSede = parseInt(element["IdSede"]) // quitar al momento de enviar para que lo guarde
                    //cargo.Key = element["IdHorario"]
                    //cargo.Index = element["IdHorario"]
                    cargo.Key = element["IdSede"]+element["IdCurso"]+element["IdHorario"]+element["IdPlan"]+element["IdPeriodo"];
                    cargo.Index = element["IdSede"]+element["IdCurso"]+element["IdHorario"]+element["IdPlan"]+element["IdPeriodo"];
                    cargo.IdHorario = element["IdHorario"]
                    cargo.sortIndex = contador
                    cargo.Seleccionado = Traslado === 1 ? toca2 === 1 ? true : false : toca === 1 || cargo.Cobrado === true ? true : false;
                    cargo.Pagar = Traslado === 1 ? toca2 === 1 ? true : false : toca === 1 || cargo.Cobrado === true ? true : false;
                    cargo["Imagen"] = element.Imagen
                    // if(el.Cobrado)
                })

            });


            send("RESET_SELECCIONADOS", { reset: [] });
            cursosAsignados[0].Cursos.forEach(curso => {
                curso.Cargos.forEach((cargo, index) => {
                    if (cargo.Seleccionado === true) {
                        if (cargo.hasOwnProperty("Cobrado")) {
                            if (!cargo.Cobrado) {
                                cargo.Valor = (cargo.Valor - cargo.Descuento)
                                cargo.precioAnterior = (cargo.Valor + cargo.Descuento)
                            }
                        }
                        if (Traslado === 0) {
                            send("SELECCIONAR", { seleccionado: cargo }); // 
                        }
                    }
                })
            })
            if (Traslado === 1) {
                send("SELECCIONAR", { seleccionado: cursosAsignados[0] }); // 
            }

            setShowForm(true)
            send("GUARDAR_HEADERS", { headers: headers })
            send("GUARDAR_CARNET", { carnet: cursosAsignados[0]["Carnet"] });
            send("GUARDAR_SEDE", { sede: cursosAsignados[0].Cursos[0]["IdSede"] });
            send("GUARDAR_CURSOS", { cursos: cursosAsignados[0].Cursos })

            if (Traslado === 0) {
                send("GUARDAR_IDSOLICITUD", { solicitud: cursosAsignados[0]["Id"] });
            } else {
                send("GUARDAR_IDSOLICITUD_TRASLADO", { solicitud: cursosAsignados[0]["Id"] });
            }
            setEstado(() => "CURSOS")
        }
    };

    return (
        <div className="bg-primarioMira px-4 shadow rounded-lg sm:p-6">
            <div className="divide-grisMira border border-grisMira rounded-lg h-30 w-full mx-auto justify-center bg-secundarioMira shadow-md shadow-grisMira">
                {/* <MenuSedes
                                    pasos={steps}
                                    solutions={solutions}
                                    handleClick={handleClick}
                                    Sede={opcionSede}
                                    handleChangeSearch={handleChangeSearch}
                                /> */}
            </div>
            <div className="mt-2 grid grid-cols-4 bg-secundarioMira shadow-md shadow-grisMira">
                <div className="px-2 py-2 col-span-full lg:col-start-1 lg:col-end-6 bg-secundarioMira shadow-md shadow-grisMira">
                    <BusquedaAlumnos
                        url={url + "/utils/busquedas"}
                        headers={headers}
                        setModal={setModal}
                        setClose={setEntrevistaAdmin}
                        setResponse={setCarnetResult}
                        metodo={"ALUMNOS_V2"}
                        opcion={"Opcion"}
                        campos={campos}
                        columnas={Traslado === 0 ? columnas : columnasTraslado}
                        titulo={"Resultados"}
                        subtitulo={"Listado que coinciden con tu búsqueda"}
                        seleccion={true}
                        setopcionSelect={setopcionSelect}
                        reg_pag={20}
                        Idsede={"IdSede"}
                        Sede={""}
                        IdCiclo={2025} // pendiente
                        handleAlumnoCta={startGetCursosAsignadosAlumno}
                        // modalidad={state.datosUsuario.Modalidad}
                        dataAlumnos={dataAlumnosBusqueda}
                        setTextoBusqueda={setTextoBusqueda}
                        flagSearch={flagSearch}
                        resetSearch={resetForm}
                        setresetForm={setresetForm}
                        isGrid={isGrid}
                        setIsGrid={setIsGrid}
                        showDialogoPlan4={showDialogoPlan4}
                        setEstado={excecuteModalIndex}
                        traslado={Traslado}
                    />
                </div>
            </div>
        </div>
    );
};

export default BusquedaAlumCursos;
